// Copyright (c) 2022 Sagacity Solutions Inc. All right reserved.
'use strict'        ;

import HTTP from "./http-server";

export default {
    get:  async function() {
        const response = await HTTP.get('v1/settings/users/');
        if (response.status == 200) {
            return response.data;
        }
    },
  save: async function(user) {
    const response = await HTTP.put(`v1/settings/users/${user.ID}`, user)
    if (response.status == 200) {
      return response.data
    }
    throw new Error(response.data.Error)
  },
  create: async function(user) {
    const response = await HTTP.post('v1/settings/users/', user)
    if (response.status == 200) {
      return response.data
    }
    throw new Error(response.data.Error)
  },
  remove: async function(user) {
    const response = await HTTP.delete(`v1/settings/users/${user.ID}`)
    if (response.status == 200) {
      return response.data
    }
    throw new Error(response.data.Error)
  }
}
